// 2026-09-22：安全通知和公众号绑定只使用当前认证身份，不接受客户或操作员ID。
import request from '@/utils/request'
export default {
  list:(beforeId?:string)=>request({url:'customer/securityNotifications',method:'GET',params:beforeId?{beforeId}:{}}),
  read:(id:string)=>request({url:'customer/securityNotifications/read',method:'POST',data:{id}}),
  binding:()=>request({url:'customer/loginSecurityBinding',method:'GET'}),
  createBinding:()=>request({url:'customer/loginSecurityBinding',method:'POST'})
}
